import { Container } from "@mantine/core";
import { useContext } from "react";
import { AuthContext } from "../../services/context";
import { getCurrentWorkspace } from "../../services/userConfig";
import {
  useCreateCampaign,
  useSendCampaign,
  useScheduleCampaign,
} from "../../api/campaigns";
import { useGetEvent } from "../../api/event";
import CampaignForm from "./CampaignForm";
import { useNavigate } from "react-router-dom";

const CreateCampaign = () => {
  const { user } = useContext(AuthContext);
  const { eventId } = getCurrentWorkspace(user);
  const { data: event } = useGetEvent(eventId);
  const { mutate, isPending } = useCreateCampaign(eventId);

  const { mutate: sendCampaign } = useSendCampaign({ eventId });
  const { mutate: scheduleCampaign } = useScheduleCampaign({ eventId });

  const navigate = useNavigate();

  const handleSubmit = (data) => {
    mutate({ ...data }, { onSuccess: () => navigate("/app/campaigns") });
  };

  const handleSendNow = (formData) => {
    mutate(
      { ...formData },
      {
        onSuccess: (createdCampaignId) => {
          sendCampaign(
            { id: createdCampaignId },
            {
              onSuccess: () => navigate("/app/campaigns"),
              onError: () =>
                navigate(`/app/campaigns/${createdCampaignId}/edit`),
            }
          );
        },
      }
    );
  };

  const handleSchedule = (formData, scheduledAt) => {
    mutate(
      { ...formData },
      {
        onSuccess: (createdCampaignId) => {
          scheduleCampaign(
            { id: createdCampaignId, scheduledAt },
            {
              onSuccess: () => navigate("/app/campaigns"),
              onError: () =>
                navigate(`/app/campaigns/${createdCampaignId}/edit`),
            }
          );
        },
      }
    );
  };

  return (
    <Container size="xl">
      <CampaignForm
        onSubmit={handleSubmit}
        isSubmitting={isPending}
        mode="create"
        event={event}
        onSendNow={handleSendNow}
        onSchedule={handleSchedule}
      />
    </Container>
  );
};

export default CreateCampaign;
